import { render, staticRenderFns } from "./team-subscription-size-calculator.vue?vue&type=template&id=5a7ae815"
import script from "./team-subscription-size-calculator.vue?vue&type=script&lang=js"
export * from "./team-subscription-size-calculator.vue?vue&type=script&lang=js"
import style0 from "./team-subscription-size-calculator.vue?vue&type=style&index=0&id=5a7ae815&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports